(function () {
  'use strict';

  var CONFIG = {
    country: 'CA',
    currency: 'CAD',
    startsAt: Date.parse('2026-09-01T07:00:00Z'),
    endsAt: Date.parse('2000-01-01T00:00:00Z'),
    tiers: [
      {
        threshold: 19900,
        variantId: 45625415663778,
        tier: '199',
        title: 'Foldable Foam Seat Pad | Elevate X',
        shortTitle: 'Elevate X Seat Pad'
      },
      {
        threshold: 49900,
        variantId: 45625417564322,
        tier: '499',
        title: 'Ultralight Closed-Cell Foam Sleeping Pad',
        shortTitle: 'Ultralight Foam Sleeping Pad'
      }
    ]
  };

  var state = {
    busy: false,
    timer: null,
    suppressBuild: false,
    error: ''
  };

  function isActive() {
    var now = Date.now();
    return window.Shopify &&
      Shopify.country === CONFIG.country &&
      Shopify.currency &&
      Shopify.currency.active === CONFIG.currency &&
      now >= CONFIG.startsAt &&
      now <= CONFIG.endsAt;
  }

  function isGiftLine(item) {
    return item &&
      item.properties &&
      String(item.properties._ca_gift || '') === 'true';
  }

  function eligibleSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (isGiftLine(item) ? 0 : (item.original_line_price || 0));
    }, 0);
  }

  function desiredTier(subtotal) {
    if (subtotal >= CONFIG.tiers[1].threshold) return CONFIG.tiers[1];
    if (subtotal >= CONFIG.tiers[0].threshold) return CONFIG.tiers[0];
    return null;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 2
      }).format(Math.max(0, cents) / 100);
    } catch (error) {
      return 'CA$' + (Math.max(0, cents) / 100).toFixed(2);
    }
  }

  function getMessage(subtotal, tier) {
    if (!isActive()) return null;

    if (subtotal >= CONFIG.tiers[1].threshold) {
      return {
        eyebrow: 'CA GIFT UNLOCKED',
        title: 'Free ' + CONFIG.tiers[1].shortTitle,
        detail: 'Your gift is added automatically to your cart.',
        progress: 100
      };
    }

    if (subtotal >= CONFIG.tiers[0].threshold) {
      return {
        eyebrow: 'CA GIFT UNLOCKED',
        title: 'Free ' + CONFIG.tiers[0].shortTitle,
        detail: 'Spend ' + money(CONFIG.tiers[1].threshold - subtotal) +
          ' more to upgrade to a free ' + CONFIG.tiers[1].shortTitle + '.',
        progress: Math.min(100, subtotal / CONFIG.tiers[1].threshold * 100)
      };
    }

    return {
      eyebrow: 'CANADA-ONLY GIFT',
      title: 'Spend ' + money(CONFIG.tiers[0].threshold - subtotal) +
        ' more for a free ' + CONFIG.tiers[0].shortTitle,
      detail: 'Orders over CA$499 receive a free ' +
        CONFIG.tiers[1].shortTitle + ' instead.',
      progress: Math.min(100, subtotal / CONFIG.tiers[0].threshold * 100)
    };
  }

  function ensureStyles() {
    if (document.getElementById('ca-gift-promotion-styles')) return;
    var style = document.createElement('style');
    style.id = 'ca-gift-promotion-styles';
    style.textContent =
      '.ca-gift-promo{margin:0 0 16px;padding:14px 16px;border:1px solid #d8e5df;' +
      'border-radius:8px;background:#f4f8f6;color:#18231f;line-height:1.35}' +
      '.ca-gift-promo__eyebrow{margin:0 0 4px;font-size:11px;font-weight:700;' +
      'letter-spacing:.12em;color:#27745e}' +
      '.ca-gift-promo__title{margin:0;font-size:14px;font-weight:700}' +
      '.ca-gift-promo__detail{margin:5px 0 0;font-size:12px;color:#52615b}' +
      '.ca-gift-promo__track{height:6px;margin-top:10px;overflow:hidden;' +
      'border-radius:999px;background:#dbe7e2}' +
      '.ca-gift-promo__fill{display:block;height:100%;border-radius:inherit;' +
      'background:#2c8b6c;transition:width .25s ease}' +
      '.ca-gift-promo__error{margin-top:6px;font-size:12px;color:#a43a2d}';
    document.head.appendChild(style);
  }

  function render(cart) {
    var subtotal = eligibleSubtotal(cart);
    var message = getMessage(subtotal, desiredTier(subtotal));
    var wrappers = document.querySelectorAll(
      '#CartDrawer .cart__checkout-wrapper, #CartPageForm .cart__checkout-wrapper'
    );

    wrappers.forEach(function (wrapper) {
      var parent = wrapper.parentElement;
      if (!parent) return;

      var box = parent.querySelector(':scope > .ca-gift-promo');
      if (!message) {
        if (box) box.remove();
        return;
      }

      if (!box) {
        box = document.createElement('div');
        box.className = 'ca-gift-promo';
        box.setAttribute('role', 'status');
        box.setAttribute('aria-live', 'polite');
        parent.insertBefore(box, wrapper);
      }

      box.innerHTML =
        '<p class="ca-gift-promo__eyebrow">' + message.eyebrow + '</p>' +
        '<p class="ca-gift-promo__title">' + message.title + '</p>' +
        '<p class="ca-gift-promo__detail">' + message.detail + '</p>' +
        '<div class="ca-gift-promo__track" aria-hidden="true">' +
        '<span class="ca-gift-promo__fill" style="width:' +
        Math.max(0, Math.min(100, message.progress)) + '%"></span></div>' +
        (state.error
          ? '<p class="ca-gift-promo__error">' + state.error + '</p>'
          : '');
    });
  }

  function cartRequest(path, payload) {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + path, {
      method: payload ? 'POST' : 'GET',
      headers: payload ? {'Content-Type': 'application/json'} : undefined,
      body: payload ? JSON.stringify(payload) : undefined,
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function refreshCart(cart) {
    render(cart);
    state.suppressBuild = true;
    document.dispatchEvent(new CustomEvent('cart:build'));
    window.setTimeout(function () {
      state.suppressBuild = false;
      render(cart);
    }, 300);
  }

  function sync() {
    if (state.busy) return;
    state.busy = true;
    state.error = '';

    cartRequest('cart.js').then(function (cart) {
      var subtotal = eligibleSubtotal(cart);
      var desired = isActive() ? desiredTier(subtotal) : null;
      var giftLines = (cart.items || []).filter(isGiftLine);
      var updates = {};
      var desiredLine = null;

      giftLines.forEach(function (item) {
        if (desired && Number(item.variant_id) === desired.variantId && !desiredLine) {
          desiredLine = item;
          if (item.quantity !== 1) updates[item.key] = 1;
        } else {
          updates[item.key] = 0;
        }
      });

      var updateKeys = Object.keys(updates);
      var updatePromise = updateKeys.length
        ? cartRequest('cart/update.js', {updates: updates})
        : Promise.resolve(cart);

      return updatePromise.then(function (updatedCart) {
        if (!desired || desiredLine) return updatedCart;

        return cartRequest('cart/add.js', {
          items: [{
            id: desired.variantId,
            quantity: 1,
            properties: {
              _ca_gift: 'true',
              _ca_gift_tier: desired.tier,
              _ca_gift_label: desired.title
            }
          }]
        }).then(function () {
          return cartRequest('cart.js');
        });
      });
    }).then(function (cart) {
      refreshCart(cart);
    }).catch(function () {
      state.error = 'We could not update your gift. Please refresh the cart or contact us.';
      return cartRequest('cart.js').then(render).catch(function () {});
    }).finally(function () {
      state.busy = false;
    });
  }

  function scheduleSync(delay) {
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(sync, typeof delay === 'number' ? delay : 250);
  }

  ensureStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(100);
    }, {once: true});
  } else {
    scheduleSync(100);
  }

  document.addEventListener('ajaxProduct:added', function () {
    scheduleSync(350);
  });

  document.addEventListener('cart:updated', function () {
    scheduleSync(250);
  });

  document.addEventListener('cart:build', function () {
    if (!state.suppressBuild) scheduleSync(350);
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest(
      '#CartDrawer input[name="updates[]"], #CartPageForm input[name="updates[]"]'
    )) {
      scheduleSync(700);
    }
  });
})();